import AccessibilityDescribedBy from './AccessibilityDescribedBy';

export default AccessibilityDescribedBy;
